const AboutGeneralRules = ({ data }) => {
  return (
    <div className="container">
      {data &&
        data.map((data, index) => (
          <div className="row g-5" key={index}>
            <div className="col-lg-12">
              <div className="inner pl--50 pl_sm--0 pl_md--0">
                <div className="section-title text-start">
                  <span className="subtitle bg-coral-opacity">{data.tag}</span>
                  <h2 className="title">{data.title}</h2>
                </div>
                {data.desc && <p>{data.desc}</p>}
                {data.list && (
                  <ul className="rbt-list-style-1">
                    {data.list.map((listData, innerIndex) => (
                      <li key={innerIndex}>
                        <i className="feather-check"></i>
                        {listData}
                      </li>
                    ))}
                  </ul>
                )}

                {data.secondTitle && <div className="section-title text-start mt--50    ">
                  <h2 className="title">{data.secondTitle}</h2>
                </div>}
                {data.secondDesc && <p>{data.secondDesc}</p>}
              </div>
            </div>
          </div>
        ))}
    </div>
  );
};

export default AboutGeneralRules;
